import {
  Form,
  Input,
  Select,
  InputNumber,
  Checkbox,
  Button,
  Card,
  Spin,
  Tag,
  Icon,
  Tooltip,
  Row,
  Col,
  Typography,
} from "antd";

import React, { Component } from "react";
import { showSuccessToast, showErrorToast } from "../general/ToastHelper";
import withSharedStateConsumer from "../../contexts/shared-state/withSharedStateConsumer";
import { AccountService } from "../../services/account/AccountService";
import { PackageAndPrivilegeService } from "../../services/packageAndPrivilege/PackageAndPrivilegeService";
import { withRouter } from "react-router-dom";
import { handleError } from "../../utils/ErrorHandlers";
import Page from "../general/Page";
import "./Accounts.css";
import "./AccountForm.css";
import "./CreateAccount.css";
import AuthorizedOnly from "../general/AuthorizedOnly";
import { Constants } from "../../data/constants";
import { Translation } from "react-i18next";
import i18next from "i18next";

import { th, tr } from "date-fns/locale";
import index from "react-app-rewire-postcss";
const { Text, Link } = Typography;

class CreateAccountForm extends Component {
  accountService = new AccountService();
  packageAndPrivilegeService = new PackageAndPrivilegeService();

  constants = new Constants();
  constructor(props) {
    super(props);
    this.props.context.setCurrentComponent("createAccounts");
    this.state = {
      account: {},
      isFetching: false,
      formLayout: "inline",
      loading: false,
      checkBoxFlag: true,
      inputVisible: false,
      inputValue: "",
      prefix: this.constants.PREFIX_NUM,
      tags: [],
      packages: [],
      accountNumbers: [],
      formChanged: false,
      cfgPackages: [],
      toggleAddMsisdn: false,
      spanValue: 24,
      msisdn: "",
    };
  }
  onChangeCheckbox(checkBoxFlag) {
    this.setState({ checkBoxFlag: !checkBoxFlag });
  }
  async getAllPackages() {
    try {
      let data = await this.packageAndPrivilegeService.getPackagesList(
        this.props.context.session_id
      );
      return data;
    } catch (e) {
      throw e;
    }
  }
  async getAllAccountMSISDN() {
    try {
      let data = await this.accountService.getAllAccountMSISDN(
        this.props.context.session_id
      );
      return data;
    } catch (e) {
      throw e;
    }
  }
  async componentDidMount() {
    try {
      this.setState({ isFetching: true });
      let [packages, accountNumbers] = await Promise.all([
        this.getAllPackages(),
        // this.getAllAccountMSISDN(),
      ]);
      this.setState({
        packages: packages.ivrList,
        cfgPackages: packages.cfgList,
        selectetedPackage: packages.ivrList[0].pkgCode,
        accountNumbers: [],
        isFetching: false,
      });
      this.state.cfgPackages.forEach((element) => {
        if (
          element.pkgCode == packages.ivrList[0].pkgCode &&
          element.key == "AGENTS_MAX_NUMBER"
        ) {
          this.props.form.setFields({
            AGENTS_MAX_NUMBER: {
              value: element.value,
            },
          });
        }
        if (
          element.pkgCode == packages.ivrList[0].pkgCode &&
          element.key == "MAX_CONCURRENT_CALLS"
        ) {
          this.props.form.setFields({
            MAX_CONCURRENT_CALLS: {
              value: element.value,
            },
          });
        }
      });
    } catch (e) {
      this.setState({ isFetching: false });
      handleError(e);
    }
  }

  handleChangeMaxAgents(e) {
    let value = e;
    let { account } = this.state;
    account.AGENTS_MAX_NUMBER = value;
    this.handleChangeMaxConcurrentCalls(value);
    this.setState({ account });
  }

  handleChangeMaxConcurrentCalls(e) {

    let value = e;
    let { account } = this.state;
    account.MAX_CONCURRENT_CALLS = value;
    this.setState({ account });
  }
  handleChangeNumOfAccountNums(e) {
    let value = e;
    this.setState({ tags: [] });
  }

  handleChange(e) {
    const { id, value } = e.target;
    let { account } = this.state;
    account[id] = value;
    this.setState({ account });
  }

  handlePackageName(e) {
    let value = e;
    let { account } = this.state;
    // account[id] = value;
    account.PKG_NAME = value;
    this.setState({ account });
  }
  handleDropdownChange = (e) => {
    this.setState({
      formChanged: true,
    });
    this.state.cfgPackages.forEach((element) => {
      if (element.pkgCode == e && element.key == "AGENTS_MAX_NUMBER") {
        this.handleChangeMaxAgents(element.value);
        this.props.form.setFields({
          AGENTS_MAX_NUMBER: {
            value: element.value,
          },
        });
      }
      if (element.pkgCode == e && element.key == "MAX_CONCURRENT_CALLS") {
        this.handleChangeMaxConcurrentCalls(element.value);
        this.props.form.setFields({
          MAX_CONCURRENT_CALLS: {
            value: element.value,
          },
        });
      }
    });
  };
  handlePrefixSelector(e) {
    let value = e;
    this.setState({ prefix: value });
  }

  handleConfirm = (e) => {
    e.preventDefault();
    let history = this.props.history;
    let msisdns = [];
    if (this.state.accountNumbers.length > 0) {
      msisdns = this.state.accountNumbers.map((element) => {
        if (!element.deleted) {
          return element.msisdn;
        }
      });
    }
    msisdns = msisdns.filter((element) => {
      return element != undefined;
    });
    this.props.form.validateFields(async (err, values) => {
      try {
        if (!err) {
          this.setState({ loading: true });
          let cfg = [
            {
              key: "PKG_NAME",
              value: values.PKG_NAME,
              configCategory: "GENERAL",
            },
            // {
            //   key: "AGENTS_MAX_NUMBER",
            //   value: values.AGENTS_MAX_NUMBER,
            //   configCategory: "GENERAL",
            // },
            // {
            //   key: "MAX_CONCURRENT_CALLS",
            //   value: values.MAX_CONCURRENT_CALLS,
            //   configCategory: "GENERAL",
            // },
            {
              key: "ACCOUNT_NUMBERS",
              value: msisdns.join(),
              configCategory: "GENERAL",
            },
          ];
          values["accountContactNumber"] = values["accountContactNumber"];
          values["billingId"] = values["billingId"];
          let data = await this.accountService.createAccount(
            this.props.context.session_id,
            values,
            cfg
          );
          this.setState({ account: data.id });

          showSuccessToast(i18next.t("Account Created Successfully"));
          this.setState({ loading: false });
          // let redirectingUrl = `/home/accounts/admin/create/${data.id}`;
          // this.state.checkBoxFlag
          //   ? history.push(redirectingUrl)
          //   : history.push("/home/accounts");
            history.push("/home/accounts")

          this.props.form.resetFields();
        }
      } catch (e) {
        this.setState({ loading: false, visible: false });
        handleError(e);
      }
    });
  };
  handleClose = (removedTag) => {
    const tags = this.state.tags.filter((tag) => tag !== removedTag);
    this.setState({ tags });
  };

  showInput = () => {
    this.setState({ inputVisible: true }, () => this.input.focus());
  };

  handleInputChange = (e) => {
    this.setState({ inputValue: e.target.value });
  };

  handleInputConfirm = () => {
    const { inputValue } = this.state;
    let { tags } = this.state;
    if (inputValue && tags.indexOf(inputValue) === -1) {
      tags = [...tags, this.constants.PREFIX_NUM + inputValue];
    }

    this.setState({
      tags,
      inputVisible: false,
      inputValue: "",
    });
  };

  saveInputRef = (input) => (this.input = input);

  checkNumber = (rule, value, callback) => {
    if (!isNaN(value)) {
      return callback();
    }
    callback(i18next.t("Please enter valid number"));
  };

  render() {
    const {
      account,
      tags,
      inputVisible,
      inputValue,
      packages,
      accountNumbers,
      selectetedPackage,
    } = this.state;

    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
    };

    const { Option } = Select;

    const packageOptions = packages.map((opt) => (
      <Option key={opt.pkgCode} value={opt.pkgCode}>
        {opt.pkgName}
      </Option>
    ));

    const accountNumbersOptions = accountNumbers.map((opt) => (
      <Option key={opt.msisdn} value={opt.msisdn}>
        {opt.msisdn}
      </Option>
    ));

    let { isFetching } = this.state;
    const prefixSelector = getFieldDecorator("prefix", {
      initialValue: this.constants.PREFIX_NUM,
    })(
      <Select
        style={{ width: 70 }}
        onChange={(e) => this.handlePrefixSelector(e)}
      >
        <Option value="010">010</Option>
        <Option value="011">011</Option>
        <Option value="012">012</Option>
        <Option value="015">015</Option>
      </Select>
    );

    return (
      <Translation>
        {(t) => (
          <Page title={t("Create Account")} hasBackArrow={true}>
            {isFetching ? (
              <Spin></Spin>
            ) : (
              <Card
                style={{
                  marginTop: "10px",
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                }}
                bordered={false}
              >
                <Form className="form-style" {...formItemLayout}>
                  <Form.Item label={t("Account Name")} {...formItemLayout}>
                    {getFieldDecorator(
                      "accountName",

                      {
                        rules: [
                          {
                            required: true,
                            message: t("Please enter valid Account Name"),
                            max: 50,
                          },
                          { initialValue: this.state.account.accountName },
                        ],
                      }
                    )(<Input />)}
                  </Form.Item>

                  {false && (
                    <Form.Item
                      label={t("Account Contact Name")}
                      {...formItemLayout}
                    >
                      {getFieldDecorator(
                        "accountContactName",

                        {
                          rules: [
                            {
                              initialValue: account.accountContactName,
                              max: 50,
                            },
                            {
                              required: true,
                              message: t(
                                "Please enter valid Account Contact Name"
                              ),
                            },
                          ],
                        }
                      )(<Input onChange={(e) => this.handleChange(e)} />)}
                    </Form.Item>
                  )}
                  <Form.Item
                    label={t("Account Contact Number")}
                    {...formItemLayout}
                  >
                    {getFieldDecorator("accountContactNumber", {
                      rules: [
                        {
                          initialValue: account.accountContactNumber,
                          required: true,
                          max: 12,
                          min: 12,
                          pattern: "^([2][0][1])(?:[0]|[1]|[2]|[5])[0-9]*$",

                          message: t(
                            "Please enter valid Account Contact Number"
                          ),
                        },
                        // {
                        //   validator: this.checkNumber,
                        // },
                      ],
                    })(
                      <Input
                        onChange={(e) => this.handleChange(e)}
                        maxLength={12}
                        placeholder="201XXXXXXXXX"
                      />
                    )}
                  </Form.Item>
                  <Form.Item
                    label={t("Account Contact Email")}
                    {...formItemLayout}
                  >
                    {getFieldDecorator("accountContactEmail", {
                      rules: [
                        {
                          type: "email",
                          message: t("The input is not valid E-mail!"),
                        },
                        { initialValue: account.accountContactEmail },

                        {
                          required: true,
                          message: t("Please enter Account Contact Email"),
                        },
                      ],
                    })(<Input onChange={(e) => this.handleChange(e)} />)}
                  </Form.Item>
                  <Form.Item label={t("Package Code")} {...formItemLayout}>
                    {getFieldDecorator(
                      "PKG_NAME",
                      { initialValue: selectetedPackage },
                      {
                        rules: [
                          {
                            required: true,
                            message: t("Please select package code"),
                          },
                        ],
                      }
                    )(
                      <Select
                        style={{ width: 120 }}
                        onChange={(value) => this.handleDropdownChange(value)}
                      >
                        {packageOptions}
                      </Select>
                    )}
                  </Form.Item>
                  <Form.Item label={t("Max Agents Number")} {...formItemLayout}>
                    {getFieldDecorator("AGENTS_MAX_NUMBER", {
                      rules: [
                        {
                          required: true,
                          message: t("Please enter Max Agents Number"),
                        },
                      ],
                    })(
                      <InputNumber
                        // min={2}
                        onChange={(e) => this.handleChangeMaxAgents(e)}
                        disabled={true}
                      />
                    )}
                  </Form.Item>
                  <Form.Item
                    label={t("Max Concurrent Calls")}
                    {...formItemLayout}
                  >
                    {getFieldDecorator("MAX_CONCURRENT_CALLS", {
                      rules: [
                        {
                          required: true,
                          message: t("Please enter Max Conncurent Calls"),
                        },
                      ],
                    })(
                      <InputNumber
                        // min={
                        //   this.state.account.AGENTS_MAX_NUMBER
                        //     ? this.state.account.AGENTS_MAX_NUMBER
                        //     : 2
                        // }
                        // max={this.state.account.AGENTS_MAX_NUMBER * 2}
                        onChange={(e) => this.handleChangeMaxConcurrentCalls(e)}
                        disabled={true}
                      />
                    )}
                  </Form.Item>
                  {/* <Form.Item label="Account Numbers" {...formItemLayout}>
                {getFieldDecorator("ACCOUNT_NUMBERS", {
                  rules: [
                    {
                      required: true,
                      message: "Please enter numbers",
                    },
                  ],
                })(<Select mode="multiple">{accountNumbersOptions}</Select>)}
              </Form.Item> */}
                  {/* <Form.Item
                label="MSISDN"
                {...formItemLayout}
                style={{
                  display:
                    this.props.context.user.msisdnType !== "alphanumeric"
                      ? "block"
                      : "none",
                }}
              >
                {getFieldDecorator(
                  "msis dn",

                  {
                    rules: [
                      {
                        required:
                          this.props.context.user.msisdnType !== "alphanumeric"
                            ? true
                            : false,
                        min: 11,
                        message: "MSISDN must be 11 digits",
                        pattern: new RegExp("^[0-9]{11}$"),
                      },
                    ],
                  }
                )(<Input maxLength={11} />)}
              </Form.Item> */}
                  <Form.Item label={t("Billing ID")} {...formItemLayout}>
                    {getFieldDecorator(
                      "billingId",

                      {
                        rules: [
                          {
                            initialValue: account.billingId,
                            max: 100,
                          },
                          {
                            required: false,
                            message: t(
                              "Please enter valid Account Contact Name"
                            ),
                          },
                        ],
                      }
                    )(<Input onChange={(e) => this.handleChange(e)} />)}
                  </Form.Item>
                  <Form.Item
                    // style={{
                    //   display:
                    //     this.props.context.user.msisdnType === "alphanumeric"
                    //       ? "block"
                    //       : "none",
                    // }}
                    label={t("Business IVR Numbers")}
                    {...formItemLayout}
                  >
                    <Row gutter={24}>
                      <Col span={this.state.spanValue}>
                        {getFieldDecorator("ACCOUNT_NUMBERS", {
                          rules: [
                            {
                              type: "string",
                              message: t("The input is not valid "),
                              min: 12,
                              max: 12,
                              pattern: "^([2][0][1])(?:[0]|[1]|[2]|[5])[0-9]*$",
                                //   pattern:
                                // this.props.context.user.msisdnType ===
                                // "alphanumeric"
                                //   ? "^[a-zA-Z0-9_@$.*]*$"
                                //   : "^([2][0][1])(?:[0]|[1]|[2]|[5])[0-9]*$",
                            },
                            {
                              required:
                                this.state.accountNumbers.length == 0
                                  ? true
                                  : false,
                              message: t("Please enter account numbers"),
                            },
                          ],
                        })(
                          <Input
                          
                            onChange={(e) => {
                                if(e.target.value.trim().length ==12 && /^([2][0][1])(?:[0]|[1]|[2]|[5])[0-9]*$/.test(e.target.value) ){
                                  this.setState({
                                    toggleAddMsisdn: true,
                                    spanValue: 22,
                                    msisdn: e.target.value,
                                  });
                                }else{
                                  this.setState({
                                    toggleAddMsisdn: false,
                                    spanValue: 24,
                                    msisdn: "",
                                  });
                                }
                              
                            }}
                            maxLength={12}
                            placeholder={t(
                              "Write msisdn and press enter to add business IVR number"
                            )}
                            onPressEnter={(e) => {
                              if(e.target.value.trim().length ==12 && /^([2][0][1])(?:[0]|[1]|[2]|[5])[0-9]*$/.test(e.target.value) ){
                                let accountNumber = { msisdn: this.state.msisdn };
                                let accountNumbers = this.state.accountNumbers;
                                accountNumbers.push(accountNumber);
                                this.setState({
                                  accountNumbers: accountNumbers,
                                  toggleAddMsisdn: false,
                                  spanValue: 24,
                                });
  
                                this.props.form.setFields({
                                  ACCOUNT_NUMBERS: {
                                    value: "",
                                  },
                                });
                              }else{
                                return;
                              }
                            
                            }}
                          />
                        )}
                         {/* <Button
                            onClick={() => {
                              let accountNumber = {
                                msisdn: this.state.msisdn,
                              };
                              let accountNumbers = this.state.accountNumbers;
                              accountNumbers.push(accountNumber);
                              this.setState({
                                accountNumbers: accountNumbers,
                                toggleAddMsisdn: false,
                                spanValue: 24,
                              });

                              this.props.form.setFields({
                                ACCOUNT_NUMBERS: {
                                  value: "",
                                },
                              });
                            }}
                            className="ant-btn-primary"
                          >
                            {t("Add")}
                          </Button>             */}
                                    </Col>

                      {this.state.toggleAddMsisdn && (
                        <Col span={2}>
                          <Button
                            onClick={() => {
                              let accountNumber = {
                                msisdn: this.state.msisdn,
                              };
                              let accountNumbers = this.state.accountNumbers;
                              accountNumbers.push(accountNumber);
                              this.setState({
                                accountNumbers: accountNumbers,
                                toggleAddMsisdn: false,
                                spanValue: 24,
                              });

                              this.props.form.setFields({
                                ACCOUNT_NUMBERS: {
                                  value: "",
                                },
                              });
                            }}
                            className="ant-btn-primary"
                          >
                            {t("Add")}
                          </Button>
                        </Col>
                      )}
                    </Row>
                  </Form.Item>
                  <Row gutter={24}>
                    <Col span={6}></Col>
                    <Col span={16}>
                      {this.state.accountNumbers.length == 0 && (
                        <Text>
                          {t("You haven't added any account number yet")}
                        </Text>
                      )}
                      {this.state.accountNumbers.map((element, index) => {
                        return (
                          <Tag
                            key={index}
                            closable={true}
                            onClose={() => {
                              let deletedIndex = index;
                              let newArray = [];
                              newArray = this.state.accountNumbers.map(
                                (element, i) => {
                                  if (i == deletedIndex) {
                                    element.deleted = true;
                                  }
                                  return element;
                                }
                              );
                              this.setState({ accountNumbers: newArray });
                            }}
                            style={{ marginTop: "5px" }}
                          >
                            {element.msisdn}
                          </Tag>
                        );
                      })}
                    </Col>
                  </Row>

                  {/* <AuthorizedOnly privileges={["CREATE.ACCOUNT.ADMIN"]}>
                    <Form.Item
                      label={t("Add Another Admin User")}
                      {...formItemLayout}
                    >
                      <Checkbox
                        checked={this.state.checkBoxFlag}
                        onChange={() =>
                          this.onChangeCheckbox(this.state.checkBoxFlag)
                        }
                      ></Checkbox>
                    </Form.Item>
                  </AuthorizedOnly> */}
                  <Form.Item
                    wrapperCol={{
                      xs: { span: 24, offset: 0 },
                      sm: { span: 16, offset: 8 },
                    }}
                  >
                    <Button
                      className="button-submit"
                      type="primary"
                      onClick={this.handleConfirm}
                      size={"small"}
                      loading={this.state.loading}
                    >
                      {t("Submit")}
                    </Button>
                  </Form.Item>
                </Form>
              </Card>
            )}
          </Page>
        )}
      </Translation>
    );
  }
}
export default Form.create()(
  withSharedStateConsumer(withRouter(CreateAccountForm))
);
